import { inject, watch, type Ref } from 'vue'
import { PAUSE_CLICK_OUTSIDE } from '@/features/interface/modal/ModalComponent.symbols'

/**
 * Composable qui suspend la détection click-outside du conteneur parent
 * quand un élément (dropdown, autocomplete, datepicker, etc.) est ouvert.
 *
 * Cela évite que le conteneur parent (modale, panel, etc.) se ferme quand
 * on clique sur un élément téléporté qui est en dehors de son DOM.
 *
 * @param isOpen - Ref booléenne indiquant si l'élément est ouvert
 */
export function useParentClickOutsidePause(isOpen: Ref<boolean>) {
  const pauseClickOutside = inject(PAUSE_CLICK_OUTSIDE, null)
  let endPause: (() => void) | null = null

  watch(isOpen, (newValue) => {
    if (newValue && pauseClickOutside) {
      pauseClickOutside(() => {
        return new Promise<void>((resolve) => {
          endPause = resolve
        })
      })
    } else if (!newValue && endPause) {
      endPause()
      endPause = null
    }
  })
}
